import { render, staticRenderFns } from "./addApplyRoomDiscount.vue?vue&type=template&id=5ddd02fe&scoped=true"
import script from "./addApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./addApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./addApplyRoomDiscount.vue?vue&type=style&index=0&id=5ddd02fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd02fe",
  null
  
)

export default component.exports